import { Controller } from '@hotwired/stimulus'

export default class TermDetailsNavigationController extends Controller {
  static targets = ['modal'];

  initNavBetweenModals(event) {
    let previousModal;
    let currentModal;
    let nextModal;

    const index = this.modalTargets.findIndex(m => m.id === event.delegateTarget.id);
    currentModal = this.modalTargets[index];
    previousModal = this.modalTargets[index - 1];
    nextModal = this.modalTargets[index + 1];

    const prevButton = currentModal.getElementsByClassName('js-button-prev')[0];
    const nextButton = currentModal.getElementsByClassName('js-button-next')[0];

    this.showHideButton(prevButton, previousModal);
    this.showHideButton(nextButton, nextModal);
  }

  showHideButton(button, element) {
    if (element) {
      button.classList.remove('invisible');
      button.dataset.bsTarget = `#${element.id}`;
    } else {
      button.classList.add('invisible');
      button.dataset.bsTarget = '';
    }
  }
}
